/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Household_RegisteredInputs */

const fr_household_registered = /** @type {(inputs: Household_RegisteredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inscrit`)
};

/**

* @param {Household_RegisteredInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const household_registered = /** @type {((inputs?: Household_RegisteredInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Household_RegisteredInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_household_registered(inputs)
});